import React, { useContext } from 'react';
import { LocationContext } from '../locationFinder';
import LocationHours from './LocationHours';
import LocationHeader from './LocationHeader';
import LocationAmenityList from './LocationAmenityList';
import LocationProductList from './LocationProductList';
import { useTranslation } from 'react-i18next';

const LocationDetails = () => {
  const { activeLocation, handleSetActiveLocation } =
    useContext(LocationContext);
  const { t } = useTranslation();
  return (
    <div className="tw-absolute tw-top-0 tw-inset-0 tw-bg-slate-100 tw-z-50 tw-pb-40">
      <div className="tw-flex tw-justify-end">
        <button
          onClick={() => handleSetActiveLocation(null)}
          className="tw-py-2 tw-grid tw-rounded-sm tw-bg-blue-light tw-border-none tw-text-white tw-px-4 tw-place-content-center">
          {'<'} {t('BACK')}
        </button>
      </div>
      <div className="px-4 tw-space-y-8">
        <LocationHeader location={activeLocation} />
        <LocationHours location={activeLocation} />
        <LocationProductList location={activeLocation} />
        <LocationAmenityList location={activeLocation} />
        <div className="tw-py-8">
          <a
            href={`https://www.google.com/maps/dir/?api=1&origin=null%2Cnull&&destination=${activeLocation.address}`}
            rel="no-follow noreferrer"
            target="_blank"
            className="py-3 text-white tw-px-4 tw-rounded-md tw-bg-blue tw-no-underline">
            {t('GET DIRECTIONS')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;
